import { useSelector } from 'react-redux';
import { SharedStoreState } from 'types';

export const selectLandingPageAccess = (state: SharedStoreState) =>
	state.landingPageAccess;
export const useSelectLandingPageAccess = () =>
	useSelector(selectLandingPageAccess);
